import React from 'react';
import { connect } from 'react-redux';
import HeaderTitle from 'header/components/title';
import { REFERRAL_MONEY_DISCOUNT, REFERRAL_FEATURE_DISCOUNT } from 'marketing/constants';

const mapStateToProps = () => {
  return {
    title: "Share crowdspring with a friend",
    subTitle: <span>
      You and your friend both get {REFERRAL_MONEY_DISCOUNT} off a future project
      <br /> plus our {REFERRAL_FEATURE_DISCOUNT} free.
    </span>
  };
}

export default connect(mapStateToProps)(HeaderTitle);



// WEBPACK FOOTER //
// ./marketing/containers/refer_a_friend_header.js